<template>
    <v-container>
        <v-row>
            <v-col>
                <h1>Your Characters</h1>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <v-card>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" v-for="(character, characterIndex) in characters"
                                   :key="characterIndex">
                                <div class="title">
                                    <v-avatar size="32" class="mb-2 mr-2">
                                        <v-img :src="getClassAvatar(character.character_class)"/>
                                    </v-avatar>
                                    {{ character.name }}
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-btn icon
                                                   color="primary"
                                                   @click="$router.push({name: 'character', params: {characterId: character.id}})"
                                                   v-on="on">
                                                <v-icon>mdi-eye</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>View Character</span>
                                    </v-tooltip>

                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on }">
                                            <v-btn icon
                                                   color="primary"
                                                   @click="$router.push({name: 'move-character-to-user', params: {characterId: character.id}})"
                                                   v-on="on"
                                            >
                                                <v-icon>mdi-account-arrow-right</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Move to another User</span>
                                    </v-tooltip>
                                </div>

                                <div v-if="character.retired" class="red--text">Retired</div>
                                <div>Campaign: {{ character.party.campaign.title }}</div>
                                <div>Party: {{ character.party.name }}</div>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

    </v-container>
</template>

<script>
  import CharacterService from "../services/CharacterService";

  export default {
    data: () => ({
      characters: []
    }),

    created() {
      if (!this.$store.state.isUserLoggedIn) {
        this.$router.push({name: 'auth'});
      }

      this.indexCharacters();
    },

    methods: {
      indexCharacters() {
        CharacterService.indexByUser(this.$store.state.user.id)
          .then(response => {
            this.characters = response.data.data;
          })
          .catch(err => {
            console.log(err);
          });
      },

      getClassAvatar(characterClass) {
        try {
          return require(`@/assets/${characterClass.slug}.png`);
        } catch (e) {
          return "";
        }
      }
    }
  };
</script>